import { useDeliveryApi } from 'infrastructure/api';
import { ResourceData, useCrudService } from 'framework/crud';
import { cloneDeep } from 'lodash';
import { BusinessOutcomesType } from './types';
import outcomesArrayValidation, { outcomesDashboardValidation } from './outcomesValidation';

const useOutcomesService = () => {
  const singleResourceUrl = '/projects/:id';
  const {
    search: baseSearch,
    update: initialUpdate,
    ...baseCrudRequests
  } = useCrudService({
    singleResourceUrl,
    listResourceUrl: '/projects',
    useService: useDeliveryApi,
  });

  const { sendPostRequest, sendPutRequest } = useDeliveryApi();

  const businessOutcomesSearch = async (id: string, request: ResourceData) => {
    const searchParams = cloneDeep(request);
    const response = await sendPostRequest(`/projects/${id}/business-outcomes/search`, searchParams);
    return response.json();
  };

  const businessOutcomesBatch = async (id: string, data: BusinessOutcomesType[]): Promise<BusinessOutcomesType[]> => {
    const res = await sendPostRequest(`/projects/${id}/business-outcomes/batch`, { batch: data });
    return res.json();
  };

  const completeBusinessOutcome = async (outcomeId: string, data: object): Promise<StringOrNumber> => {
    const response = await sendPutRequest(`/projects/business-outcomes/${outcomeId}/complete`, { data });
    return response.json();
  };

  const getOutcomesValidationSchema = () => Promise.resolve(outcomesArrayValidation);
  const getOutcomesDashboardValidationSchema = () => Promise.resolve(outcomesDashboardValidation);

  return {
    ...baseCrudRequests,
    businessOutcomesSearch,
    businessOutcomesBatch,
    completeBusinessOutcome,
    getOutcomesValidationSchema,
    getOutcomesDashboardValidationSchema,
  };
};

export default useOutcomesService;
